import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useAuth } from "../auth/AuthProvider";
import { LanguageSwitch } from "../components/AppShell";
import { BrandFooterLine, BrandLogo } from "../components/Brand";
import { AUTHORITY } from "../lib/auth";

export default function SignIn() {
  const { t } = useTranslation();
  const { signIn, status } = useAuth();
  const location = useLocation();
  return (
    <main className="flex min-h-screen flex-col bg-gradient-to-br from-brand-primary via-brand-deep to-brand-deep-2 text-white">
      <div className="flex justify-end p-4"><LanguageSwitch /></div>
      <div className="flex flex-1 items-center justify-center px-6 pb-16">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 text-brand-charcoal shadow-2xl">
          <BrandLogo variant="light" className="mx-auto h-14" />
          <h1 className="mt-6 text-center font-heading text-2xl font-semibold text-brand-primary">OneSphere</h1>
          <p className="mt-1 text-center text-sm text-brand-grey">{t("landing.title")}</p>
          <button
            onClick={() => void signIn(location.pathname)}
            disabled={status === "loading"}
            data-testid="signin-sso"
            className="mt-8 w-full rounded-lg bg-brand-red px-4 py-3 font-heading text-sm font-semibold text-white shadow hover:bg-brand-red-hover disabled:opacity-60">
            {status === "loading" ? t("auth.checking") : t("auth.signIn")}
          </button>
          <p className="mt-4 text-center text-xs text-brand-grey">{t("auth.signInHint")}</p>
          <p className="mt-6 truncate text-center text-[10px] text-brand-grey-light" title={AUTHORITY}>{AUTHORITY}</p>
        </div>
      </div>
      <footer className="flex flex-wrap items-center justify-between gap-2 px-6 py-3 text-[11px] tracking-wide text-white/70">
        <BrandFooterLine />
        <span className="ml-auto flex items-center gap-2 rounded bg-white/90 px-2 py-1 text-brand-grey">
          Powered by <img src="/brand/ethx-logo.png" alt="ETHX Softcon" className="h-4" />
        </span>
      </footer>
    </main>
  );
}
